import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { resetUserContext } from 'actions/user';

/*
  This is a page for clearing cache / local storage and redirecting to index route
 */
const ClearCache = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [localStorageCleared, setLocalStorageCleared] = useState(false);
  const [sessionStorageCleared, setSessionStorageCleared] = useState(false);
  const [cookiesCleared, setCookiesCleared] = useState(false);

  const handleClearLocalStorage = async () => {
    await localStorage.clear();
    setLocalStorageCleared(true);
  };

  const handleClearSessionStorage = async () => {
    await sessionStorage.clear();
    setSessionStorageCleared(true);
  };

  const handleClearCookies = async () => {
    const cookies = document.cookie;
    await cookies.split(';').forEach(cookie => {
      const pos = cookie.indexOf('=');
      const name = pos > -1 ? cookie.substr(0, pos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    });
    setCookiesCleared(true);
  };

  const handleClearCache = async () => {
    dispatch(resetUserContext());
    await handleClearLocalStorage();
    await handleClearSessionStorage();
    await handleClearCookies();
  };

  useEffect(() => {
    handleClearCache();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const allClear =
      localStorageCleared && sessionStorageCleared && cookiesCleared;
    if (allClear) {
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorageCleared, sessionStorageCleared, cookiesCleared]);

  const allClear =
    localStorageCleared && sessionStorageCleared && cookiesCleared;

  return (
    <>
      <p>{localStorageCleared && 'Local Storage cleared'}</p>
      <p>{sessionStorageCleared && 'Session storage cleared'}</p>
      <p>{cookiesCleared && 'Cookies cleared'}</p>
      <p>{allClear && 'Navigating to login'}</p>
    </>
  );
};

export default ClearCache;
